var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1562,
    height: 488,
    viewBox: "0 0 1562 488",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.051 434.54H166.455L205.308 0L293.804 0L330.085 434.54H344.489V0L496.539 0L413.238 488H291.232L248.27 204.067L205.308 488H83.3009L0 0L152.051 0L152.051 434.54ZM784.006 488H630.619L656.903 369.301H589.44L615.721 488L462.337 488L545.19 0L701.202 0L784.006 488ZM926.453 434.54H941.003L1004.01 369.252H1022.87V488H817.661L812.217 0L933.48 0L926.453 434.54ZM1171.71 434.54H1186.26L1249.32 369.252H1268.17V488H1062.92L1057.47 0L1178.73 0L1171.71 434.54H1171.71ZM1343.33 0L1380.8 263.168L1394.86 263.168L1432.32 0L1562 0L1444.15 316.334L1448.85 488L1326.8 488L1331.5 316.334L1213.65 0L1343.33 0ZM589.44 318.099H656.903L630.175 51.839H616.168L589.44 318.099Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordmark);
export default __webpack_public_path__ + "static/media/wordmark.c93f2bd440e790a8174c445a1588042f.svg";
export { ForwardRef as ReactComponent };